var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer flex-col"},[_c('span',{staticClass:"text_51"},[_vm._v("主办：北京市文物局"),_c('br'),_vm._v("承办：京报移动传媒有限公司")])])}]

export { render, staticRenderFns }